import { ACCESS_TOKEN_KEY, IS_LOGGED_IN_KEY } from "./constants";
import Cookies from "js-cookie";

export function useToken() {
  return {
    setToken(token: string) {
      Cookies.set(ACCESS_TOKEN_KEY, token, { expires: 1 });
    },
    getToken() {
      return Cookies.get(ACCESS_TOKEN_KEY);
    },
    removeToken() {
      Cookies.remove(ACCESS_TOKEN_KEY);
    },
    hasToken() {
      return !!Cookies.get(IS_LOGGED_IN_KEY);
    },
  };
}
